import {Component, Input, OnInit} from '@angular/core';
import {LaundryStatus} from './utility-status.component';
import {NzIconDirective} from 'ng-zorro-antd/icon';

@Component({
    selector: 'app-laundry-icon',
    imports: [
        NzIconDirective
    ],
    template: `
    <div #skill class="skill" [style.--deg]="deg">
      @if (machine) {
        <div class="icon" style="background-image: url({{iconUrl}})">
          @if (machine.status === 'A' && text !== '999') {
            <span class="text">{{ text }}</span>
          } @else {
            <span class="unavailable" nz-icon
                  nzType="warning" nzTheme="outline"></span>
          }
        </div>
      }
    </div>
  `,
    styles: `
    .icon {
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      background-size: 100% 100%;
      aspect-ratio: 1;
    }


    .text {
      width: 50%;
      font-weight: bold;
      opacity: .9;
      text-align: center;
    }

    .unavailable {
      color: darkred;
      width: 100%;
      height: 100%;
      font-size: 4vw;
      font-weight: bold;
      opacity: .9;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: rgba(128, 128, 128, 0.7);
    }


    .skill {
      position: relative;
      width: 100%;
      height: 100%;
      overflow: hidden;
      --deg: 0%;
    }


    .skill::before {
      content: "";
      background: conic-gradient(
        rgba(0, 0, 0, 0.7) var(--deg),
        rgba(0, 0, 0, 0.1) 0%);
      position: absolute;
      opacity: 0.8;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
    }
  `
})
export class LaundryIconComponent implements OnInit {

  @Input()
  machine: LaundryStatus | undefined;
  iconUrl = '';
  deg = '0%';
  text = '';

  constructor() {
  }

  ngOnInit(): void {
    if (this.machine?.status === 'A') {
      this.deg = `${Math.round(this.machine.left / 60 * 100)}%`;
      this.text = this.machine.left === 0 ? `` : `${this.machine.left}`;
      this.iconUrl = this.machine.type === 'D' ? 'assets/dryer-icon.svg' : 'assets/washer-icon.svg';
    }
  }


}
